import meta from '../metadata';

export const Routes = meta.Routes;

export const hubId = 'hub';

export enum SandboxSection {
  DataViz = 'dataviz',
}

export enum DataVizSections {
  LineChart = 'linechart',
  GeoMap = 'geomap',
}
